/*
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

module.exports = [
	'baseline widely available with downstream and last 2 major versions and not dead',
	'baseline widely available with downstream and >0.05% and not dead',
	'firefox esr'
]
